var _rect, _path, _path2, _path3, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgChatsUpdates = function SvgChatsUpdates(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 5.3,
    fill: "#EFF7DF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2 7.59961H8.8C7.8058 7.59961 7 8.40541 7 9.39961V17.1996V17.6964C7 18.744 8.1844 19.3536 9.037 18.7446L10.7302 17.535C11.0356 17.3166 11.4016 17.1996 11.7766 17.1996H17.2C18.1942 17.1996 19 16.3938 19 15.3996V9.39961C19 8.40541 18.1942 7.59961 17.2 7.59961Z",
    fill: "#5A6367"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7996 11.7996H11.1996C10.8678 11.7996 10.5996 11.5308 10.5996 11.1996C10.5996 10.8684 10.8678 10.5996 11.1996 10.5996H14.7996C15.1314 10.5996 15.3996 10.8684 15.3996 11.1996C15.3996 11.5308 15.1314 11.7996 14.7996 11.7996Z",
    fill: "#C5C5CA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5996 14.2H11.1996C10.8678 14.2 10.5996 13.9312 10.5996 13.6C10.5996 13.2688 10.8678 13 11.1996 13H13.5996C13.9314 13 14.1996 13.2688 14.1996 13.6C14.1996 13.9312 13.9314 14.2 13.5996 14.2Z",
    fill: "#C5C5CA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 5.3,
    stroke: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChatsUpdates);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "chats-updates.7c625cd4428be08b157002fdfa4fcfae.svg";